import { track } from "@vercel/analytics/react";

import { apiFetch } from "@/lib/api";

type ProductEvent =
  | "scorecard_submitted"
  | "scorecard_released"
  | "report_delivered"
  | "members_provisioned"
  | "deck_uploaded"
  | "deck_opened"
  | "session_recording_opened"
  | "prompt_pack_opened"
  | "prompt_copied"
  | "playbook_viewed"
  | "playbook_started"
  | "playbook_step_completed"
  | "playbook_completed"
  | "playbook_resource_opened";

type EventProps = Record<string, string | number | boolean | null>;

// Content events with no database record of their own. Mirrored to our API so
// the Engagement page can attribute them to a member's organization, which
// Vercel Web Analytics can't do.
const RECORDED_EVENTS = new Set<string>([
  "deck_opened",
  "session_recording_opened",
  "prompt_pack_opened",
  "prompt_copied",
  "playbook_viewed",
  "playbook_resource_opened",
]);

let recordingEnabled = false;

export function setActivityRecording(enabled: boolean) {
  recordingEnabled = enabled;
}

function recordActivity(name: string, props?: EventProps) {
  if (!recordingEnabled) return;
  apiFetch("/api/scorecards/activity/", {
    method: "POST",
    json: { name, properties: props ?? {} },
  }).catch(() => {});
}

// Fire-and-forget product usage events (Vercel Web Analytics). No-ops outside
// Vercel deployments. Keep properties to business facts — never user PII.
export function trackEvent(name: ProductEvent, props?: EventProps) {
  track(name, props);
  if (RECORDED_EVENTS.has(name)) recordActivity(name, props);
}
